import type { ButtonHTMLAttributes, FC } from 'react';

import cn from 'classnames';

import { GLASS_CLASSES } from './_styles/glass';

type GlassIconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  'aria-label': string;
};

export const GlassIconButton: FC<GlassIconButtonProps> = ({ className, children, ...props }) => {
  return (
    <button type="button" className={cn(GLASS_CLASSES, className)} {...props}>
      {children}
    </button>
  );
};
